<template>
    <div class="billOperationRecord public_Spacing">
        <div class="pulbic_oparetionBlock">
            <div class="public_criteriaRange">
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">客户：</label>
                    <!-- <el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择"
                        filterable>
                        <el-option v-for="item in customerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
                            :value="item.ORMTB410ID">
                        </el-option>
                    </el-select> -->
                    <EnhancedSelect v-model="customerMo" :options="customerOptions" label-key="ORMTB410CA00"
                        value-key="ORMTB410ID" pinyin-key="ORMTB410CA13" :enable-pinyin-search="true"
                        :enable-first-letter-search="true" />
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">企业：</label>
                    <!-- <el-select class="public_optionSty dropDown_Define" @change="erpChange" v-model="enterpriseTwo"
                        placeholder="请选择" filterable>
                        <el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
                            :label="item.SETTB99CA00" :value="item.SETTB99ID">
                        </el-option>
                    </el-select> -->
                    <EnhancedSelect v-model="enterpriseTwo" :options="enterpriseTwoOptionList" label-key="SETTB99CA00" value-key="SETTB99ID"
            pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true" :enable-first-letter-search="true" @change="erpChange" />
                </div>
                <div class="public_oparetionBlock_Menu">
                    <label class="public_lbSty">物料：</label>
                    <el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
                        filterable>
                        <el-option v-for="item in materielOptions" :key="item.SETTB109ID" :label="item.SETTB109CA00"
                            :value="item.SETTB109ID">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="public_operatArea" style="margin-bottom: 10px;">
                <div class="public_operatBtn">
                    <button @click="addClick"
                        class="public_saleWater_chaxun pulic_cursor public_saleWater_xinzeng">新增</button>
                    <button @click="queryClick" class="public_saleWater_chaxun pulic_cursor">查询</button>
                </div>
            </div>
        </div>
        <div class="billOperationRecord-table pulbic_table_container">
            <el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
                :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    background: 'rgba(184,227,255,1)',
                    'font-weight': 'bold',
                }" class="public_tableColumn">
                <el-table-column align="center" prop="SETTB420CA04" label="客户名称"></el-table-column>
                <el-table-column align="center" prop="SETTB420CA00" label="企业名称"></el-table-column>
                <el-table-column align="center" prop="SETTB420CA02" label="物料名称"></el-table-column>
                <el-table-column align="center" prop="SETTB420CA07" label="返点比率"></el-table-column>
                <el-table-column align="center" prop="SETTB420CA09" label="开始时间"></el-table-column>
                <el-table-column align="center" prop="SETTB420CA10" label="结束时间"></el-table-column>
                <el-table-column align="center" label="操作" width="260">
                    <template slot-scope="scope">
                        <el-button class="public_icon_xiugai public_icon_width" type="info" size="small"
                            @click="deleteFd(scope.row)" id="删除">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pulbic_pagesize">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                    layout="total,sizes, prev, pager, next" :total="pagingPageMo">
                </el-pagination>
            </div>
        </div>
        <!--返点调控-->
        <div class="public-dialog">
            <el-dialog title="新增返点信息" :visible.sync="fandianShow" width="25%" :closeOnClickModal="false">
                <div class="systemCorporateAccount-dialog">
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">客户名称<span>*</span></div>
                        <div class="SCADL-input">
                            <el-select class="public_optionSty dropDown_Define" v-model="fdObj.khId" placeholder="请选择"
                                filterable @change="khChange">
                                <el-option v-for="item in customerOptionsAll" :key="item.ORMTB410ID"
                                    :label="item.ORMTB410CA00" :value="item.ORMTB410ID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">企业名称<span>*</span></div>
                        <div class="SCADL-input">
                            <el-select class="public_optionSty dropDown_Define" @change="fdPageMaterialList"
                                v-model="fdObj.cjId" placeholder="请选择" filterable>
                                <el-option v-for="item in enterpriseTwoOptionListAll" :key="item.SETTB99ID"
                                    :label="item.SETTB99CA00" :value="item.SETTB99ID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">物料名称</div>
                        <div class="SCADL-input">
                            <el-select class="public_optionSty dropDown_Define" @change="onSelecteLable"
                                @clear="clearFunWl" v-model="fdObj.wls" clearable multiple collapse-tags
                                placeholder="请选择" filterable>
                                <el-option v-for="item in fdmaterList" :key="item.SETTB109ID" :label="item.SETTB109CA00"
                                    :value="item.SETTB109ID">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">返点比率<span>*</span></div>
                        <div class="SCADL-input">
                            <input type="text" v-model="fdObj.fdbl" placeholder="请输入" />
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">开始时间<span>*</span></div>
                        <div class="SCADL-input">
                            <el-date-picker v-model="fdObj.startTime" type="datetime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-li">
                        <div class="SCADL-text">结束时间<span>*</span></div>
                        <div class="SCADL-input">
                            <el-date-picker v-model="fdObj.endTime" type="datetime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="systemCorporateAccount-dialog-btn">
                        <el-button type="primary" @click="commitVerify">保存</el-button>
                        <el-button type="warning" @click="fandianShow = false">取消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import EnhancedSelect from './components/EnhancedSelect.vue';
export default {
    components: {
        EnhancedSelect
    },
    data() {
        return {
            uobj: this.$store.state.uobj, //登陆缓存--用户信息
            tableData: [],
            ORMTB440CA00: '',
            ORMTB470CA12: '',
            ORMTB470CA40: '',
            ORMTB410CA04: '',
            materialOptions: [],
            materialTypeValue: '',
            customerOptions: [
                {
                    ORMTB410ID: '',
                    ORMTB410CA00: '全部',
                },
            ],
            customerOptionsAll: [],
            carNum: '',
            materielMo: '',
            materielOptions: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ],
            // 查询
            customerMo: '', //客户--查询
            SETTB122CA07: '', //数据状态
            enterpriseTwoOptionList: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ], //二级企业下拉框--新增
            enterpriseTwo: '', //二级企业
            carNumber: '', //车牌号
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            currentPage: 1, //设置当前页默认为1
            // 历史缓存
            currentUrl: this.$route.path,
            historyInfo: '',
            fandianShow: false,
            fdObj: {
                cjName: '',
                cjId: '',
                fdbl: '',
                wlName: '',
                wlId: '',
                wls: [],
                wlobjs: [],
                khName: '',
                khId: '',
                startTime: '',
                endTime: '',
            },
            cjList: [],
            fdmaterList: [],
            enterpriseTwoOptionListAll: []
        }
    },
    created() {
        var list = ''
        list = this.$store.state.solelist
        // 赋值，缓存销毁
        this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
        sessionStorage.removeItem(this.currentUrl)
        if (this.historyInfo != null && this.historyInfo != '') {
            this.init()
        }
        // else {
        // 	this.getNowDay();
        // }
        var path = this.$route.path
        // console.log(path)
        if (path === '/rebateSetting') {
            path = '/Home' + path
        }
        this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
    },
    mounted() {
        this.optionLists()
        this.enterprise0ptions()
        this.queryClick()
    },
    methods: {
        khChange(value) {
            const item = this.customerOptionsAll.find(item => item.ORMTB410ID === value);
            this.fdObj.khName = item.ORMTB410CA00;
        },
        deleteFd(item) {
            var postData = {
                SETTB420ID: item.SETTB420ID,
            }
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    let loading = this.$loading({
                        lock: true,
                        text: '请求中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)',
                    })
                    var url = 'set/settb420/delete'
                    this.axios
                        .post(url, postData)
                        .then(res => {
                            setTimeout(() => {
                                loading.close()
                            }, 300)
                            if (res.data.code == 200) {
                                this.queryClick();
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!',
                                })
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'error',
                                })
                            }
                        })
                        .catch(() => {
                            loading.close()
                        })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    })
                })
        },
        commitVerify() {
            if (this.fdObj.khId.trim().length == 0)
                return this.$message.error('请选择客户')
            if (this.fdObj.cjName.trim().length == 0)
                return this.$message.error('请选择厂家')
            if (this.fdObj.fdbl.toString().trim().length == 0)
                return this.$message.error('请输入返点比率')
            if (this.fdObj.startTime.length === 0)
                return this.$message.error('请选择开始时间')
            if (this.fdObj.endTime.length === 0)
                return this.$message.error('请选择结束时间')
            if (!/^-?\d+(\.\d+)?$/.test(this.fdObj.fdbl)) {
                return this.$message.error('请输入有效的返点比率')
            }
            if (this.fdObj.startTime >= this.fdObj.endTime) {
                return this.$message.error('结束时间需大于开始时间')
            }
            if (this.fdObj.wlobjs.length == 0) {
                this.$confirm('不选择物料将对所有物料进行设置, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                    .then(() => {
                        this.commitFdModify()
                    })
                    .catch(() => { })
            } else {
                this.commitFdModify()
            }
        },
        dateFtt(fmt, date) {
            //author: meizz
            var o = {
                'M+': date.getMonth() + 1, //月份
                'd+': date.getDate(), //日
                'h+': date.getHours(), //小时
                'm+': date.getMinutes(), //分
                's+': date.getSeconds(), //秒
                'q+': Math.floor((date.getMonth() + 3) / 3), //季度
                S: date.getMilliseconds(), //毫秒
            }
            if (/(y+)/.test(fmt))
                fmt = fmt.replace(
                    RegExp.$1,
                    (date.getFullYear() + '').substr(4 - RegExp.$1.length)
                )
            for (var k in o)
                if (new RegExp('(' + k + ')').test(fmt))
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1
                            ? o[k]
                            : ('00' + o[k]).substr(('' + o[k]).length)
                    )
            return fmt
        },
        commitFdModify() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                SETTB420CA00: this.fdObj.cjName,
                SETTB420CA01: this.fdObj.cjId,
                SETTB420CA02: this.fdObj.wlName,
                SETTB420CA03: this.fdObj.wlId,
                SETTB420CA04: this.fdObj.khName,
                SETTB420CA05: this.fdObj.khId,
                SETTB420CA07: this.fdObj.fdbl,
                SETTB420CA09: this.dateFtt(
                    'yyyy-MM-dd hh:mm:ss',
                    new Date(this.fdObj.startTime)
                ),
                SETTB420CA10: this.dateFtt(
                    'yyyy-MM-dd hh:mm:ss',
                    new Date(this.fdObj.endTime)
                ),
                WLOBJS: this.fdObj.wlobjs,
            }
            var url = 'set/settb420/save'
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        this.fandianShow = false
                        this.queryClick()
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: '保存失败',
                            type: 'error',
                        })
                        this.fandianShow = false
                    }
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                })
                .catch(() => {
                    loading.close()
                })
        },
        clearFunWl() {
            this.fdObj.wlId = ''
            this.fdObj.wlName = ''
        },
        changjiaList(data) {
            var url = '/set/settb100/selectSettb100ByCa02'
            var loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
                type: 1,
            }
            this.axios
                .post(url, postData)
                .then(res => {
                    // console.log(res)
                    if (res.data.code == 200) {
                        console.log(res)
                        this.cjList = res.data.data
                        //this.selectData()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                })
                .catch(() => {
                    loading.close()
                })
        },
        onSelecteLable() {
            const idSet = new Set(this.fdObj.wls)
            this.fdObj.wlobjs = this.fdmaterList.filter(item =>
                idSet.has(item.SETTB109ID)
            )
        },
        onSelecteLableCj() {
            let obj = {}
            obj = this.enterpriseTwoOptionListAll.find(item => {
                //这里的userList就是上面遍历的数据源
                return item.SETTB99ID === this.fdObj.cjId //筛选出匹配数据
            })
            this.fdObj.cjName = obj.SETTB99CA00
        },
        /*根据厂家查物料*/
        fdPageMaterialList() {
            this.fdObj.wlId = ''
            console.log(JSON.stringify(this.uobj))
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                SETTB99ID: this.fdObj.cjId,
                SETTB109CD01: '',
                limit: '1000',
                page: '1',
            }
            this.materList = []
            var fdmoList
            var url = 'set/settb109/selectPageList'
            this.axios
                .post(url, postData)
                .then(res => {
                    // console.log(res)
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                    if (res.data.code == 200) {
                        fdmoList = res.data.data
                        this.fdmaterList = fdmoList
                        this.fdpagingPageMaterial = res.data.count
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
            this.onSelecteLableCj()
        },
        selectwlhxPageListFun() {
            //根据厂家获取物料含税价和不含税价信息
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                SETTB99ID: this.fdObj.cjId,
                ORMTB410ID: this.objuserMsg.ORMTB410ID,
                limit: this.hsjListlimitMaterial,
                page: this.hsjListpageMaterial,
            }
            this.materList = []
            var fdmoList
            var url = 'set/settb109/selectwlhxPageList'
            this.axios
                .post(url, postData)
                .then(res => {
                    console.log(res)
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                    if (res.data.code == 200) {
                        fdmoList = res.data.data.list
                        this.fdmaterList = fdmoList
                        this.hsjListpagingPageMaterial = res.data.count

                        if (res.data.data.taxSwitch == 0) {
                            this.hanshuijiaKG = false
                            this.hsjstus = 0
                        } else {
                            this.hanshuijiaKG = true
                            this.hsjstus = 1
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        // 新增
        addClick() {
            this.fandianShow = true;
            this.fdObj = {
                cjName: '',
                cjId: '',
                fdbl: '',
                wlName: '',
                wlId: '',
                wls: [],
                wlobjs: [],
                khName: '',
                khId: '',
                startTime: '',
                endTime: '',
            }
        },
        // 获取派单物料列表
        getSelectMaterial(row) {
            var postData = {
                SETTB99ID: row.ORMTB470CA04,
            }
            this.materialList = []
            postData = qs.stringify(postData)
            var url = '/set/settb109/select_material'
            this.axios
                .post(url, postData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.materialList = res.data.data
                        // this.materialValue = this.detailsList.ORMTB440CC01
                        if (this.detailsList.ORMTB470CA18) {
                            this.materialValue = this.detailsList.ORMTB470CA18
                        } else {
                            this.materialValue = this.detailsList.ORMTB470CA06
                            // console.log(this.detailsList)
                            this.queryMaterialPrice(this.materialValue)
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        //初始化数据
        init() {
            this.currentPage = this.historyInfo.currentPage
            this.pageMo = this.historyInfo.pageMo
            this.limitMo = this.historyInfo.limitMo
        },
        // 客户--查询
        enterprise0ptions() {
            var postData = {}
            if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
                postData = {
                    ORMTB400ID: this.uobj.ormtb410.ORMTB410ID, //一级企业id
                }
            }
            if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
                postData = {
                    ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级企业id
                }
            }

            var List = [
                {
                    ORMTB410ID: '',
                    ORMTB410CA00: '全部',
                },
            ]
            var url = '/orm/ormtb410/selectOrmtb410s'
            this.axios.post(url, postData).then(res => {
                console.log(res)

                if (res.data.code == 200) {
                    // 客户
                    this.customerOptions = [...List, ...res.data.data]
                    this.customerOptionsAll = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        materielMoPost() {
            var i = (this.enterpriseTwoOptionList || []).findIndex(
                profile => profile.SETTB99ID === this.enterpriseTwo
            )
            var url = '/set/settb109/selectPageList'
            var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
            var data = {
                SETTB109CA03: '',
                SETTB109CA00: '',
                SETTB109CD01: SETTB100ID,
                SETTB99ID: this.enterpriseTwo,
                page: 1,
                limit: 1000,
            }
            var List = [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ]
            this.axios.post(url, data).then(res => {
                if (res.data.code == 200) {
                    this.materielOptions = [...List, ...res.data.data]
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        erpChange() {
            if (this.enterpriseTwo != '') {
                this.materielMoPost()
            } else {
                this.materielOptions = [
                    {
                        SETTB109CA00: '全部',
                        SETTB109ID: '',
                    },
                ]
            }
        },
        // 获取下拉框信息--二级企业
        optionLists() {
            var postData = {
                type: 2,
                SETTB100CA02: '', //用户类型
            }
            if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
                postData = {
                    type: 2,
                    ORMTB400ID: this.uobj.ormtb410.ORMTB400ID, //一级企业id
                }
            }
            if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
                postData = {
                    type: 2,
                    ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级企业id
                }
            }
            // var postData = {
            // 	SETTB100CA02: '', //用户类型
            // 	ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
            // }
            var List = [
                {
                    SETTB99ID: '',
                    SETTB99CA00: '全部',
                },
            ]
            var url = '/set/settb100/selectSettb100ByCa02'
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data
                        // 二级企业
                        this.enterpriseTwoOptionList = [...List, ...data]
                        this.enterpriseTwoOptionListAll = data;
                        if (this.enterpriseTwoOptionList.length == 2) {
                            this.enterpriseTwo = this.enterpriseTwoOptionList[1].SETTB99ID
                            this.materielMoPost()
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    this.pageList()
                })
                .catch(() => {
                    this.pageList()
                    loading.close()
                })
        },
        // 查询
        queryClick() {
            this.pageList()
        },
        // 列表
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                SETTB420CA05: this.customerMo,
                SETTB420CA01: this.enterpriseTwo,
                SETTB420CA03: this.materielMo,
                page: this.pageMo,
                limit: this.limitMo,
            }
            var url = 'set/settb420/list'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 300)
                    if (res.data.code == 200) {
                        this.tableData = res.data.data
                        this.pagingPageMo = res.data.count
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
    },
}
</script>

<style scoped>
.CustomerfillingDig-tab {
    padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
    display: flex;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    color: #333;
    vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
    /* border: 1px solid #cdcdcd; */
    border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
    border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
    /* border-top: 1px solid #cdcdcd; */
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
    border: none;
    color: #ff4d35;
}

.CustomerfillingDig-tab-li-text {
    flex: 0.8;
    background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
    flex: 0.8;
}

.rechargeType-tab-li-text {
    flex: 0.35;
}

.rechargeType-tab-li-ipt {
    flex: 0.7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
    height: 46px;
    width: 100%;

    text-align: center;

    box-sizing: border-box;
    font-size: 16px;
    color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
    outline: none;
    border: none;
    vertical-align: top;
}

.rechargeType-tab-li-ipt input {
    /* border-radius: 8px; */
    /* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
    flex: 0.3;
}

.CustomerfillingDig-tab-btn {
    text-align: center;
    margin-top: 30px;
}

.DWD-li {
    display: flex;
    height: 35px;
    line-height: 35px;
    box-sizing: border-box;
    /* border: 1px solid #999; */
    font-size: 16px;
    color: #333;
}

.DWD-li>div {
    padding: 0 5px;
    height: 34px;
    overflow: hidden;
    box-sizing: border-box;
}

.DWD-li-title {
    width: 150px;
    text-align: center;
    border-right: 1px solid #999;
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-li-text {
    flex: 1;
}

.DWD-li-text input {
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 0.833vw;
    border: none;
    outline: none;
}

.DWD-li+.DWD-li {
    border-top: none;
}

.DWD-table {
    display: flex;
}

.DWD-table-left-flex {
    flex: 1;
}

.DWD-table>div>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    text-align: center;
    border-right: 1px solid #999;
    /* border-bottom: 1px solid #999; */
    box-sizing: border-box;
}

.DWD-table>div>div:first-child {
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title>div {
    width: 101px;
    text-align: center;
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    box-sizing: border-box;
    border-left: 1px solid #999;
    /* border-bottom: 1px solid #999; */
}

.DetailsWater-img {
    margin-top: 30px;
}

.DetailsWater-img-text {
    display: inline-block;
    width: 101px;
    text-align: center;
    vertical-align: top;
}

.car-number-add {
    /* text-transform: uppercase; */
}

.billOperationRecord-table {
    padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
    background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
    flex: 1.5;
}

.fontBlue {
    color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
    height: 45px;
    align-items: center;
}

.billOperationRecord {
    background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
    text-align: center !important;
}

/* 统计 START*/
.imgStatistics {
    width: 40px;
    height: 40px;
}

.payType {
    /* font-size: 15px; */
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
}

.singular {
    /* font-size: 14px; */
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    vertical-align: middle;
    padding-left: 10px;
}

.Amount {
    /* font-size: 14px; */
    font-family: Microsoft YaHei;
    /* font-weight:bold; */
    line-height: 30px;
    vertical-align: middle;
    padding-left: 10px;
}

.pulic_statistics_titlt {
    line-height: 40px;
    /* font-size: 14px; */
}

.billDetails-statistics {
    justify-content: space-around;
}

.public_statisticsInfo {
    margin-top: 5px;
    margin-bottom: 10px;
}

.input_ {
    display: flex;
    height: 2.34vw;
    line-height: 2vw;
}

::v-deep .el-input__inner {
    /* width: 7.083vw; */
    height: 1.7vw;
}

:v-deep .el-input {
    width: unset;
}

/* 统计 END*/
.public_operatBtn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 0 !important;
}

.public_operatArea {
    margin-bottom: 0;
}

.systemCorporateAccount-dialog {
    padding: 0 20px;
}

.systemCorporateAccount-dialog-li {
    display: flex;
    box-sizing: border-box;
}

.systemCorporateAccount-dialog-li+.systemCorporateAccount-dialog-li {
    margin-top: 20px;
}

.systemCorporateAccount-dialog-btn {
    text-align: center;
    margin-top: 40px;
}

.systemCorporateAccount-wuliao-input>input {
    height: 40px;
    box-sizing: border-box;
    /* border: 1px solid #dcdfe6; */
    border-radius: 5px;
    padding-left: 5px;
}

.SCADL-text {
    height: 30px;
    line-height: 30px;
    flex: 0.35;
    font-size: 18px;
    color: #333;
}

.SCADL-text span {
    color: red;
}

.SCADL-input {
    flex: 1;
    box-sizing: border-box;
}

.SCADL-input input {
    height: 40px;
    line-height: 30px;
    width: 260px;
    padding-left: 10px;
    border: 1px solid #DCDFE6;
    color: #333;
    font-size: 18px;
    border-radius: 5px;
    box-sizing: border-box;
}

.SCADL-input .el-input {
    font-size: 18px;
}

.num {
    color: #333;
    font-size: 18px;
}

.cJ-btn {
    margin-top: 20px;
}

.shouQuanChangJia-dialog .el-checkbox {
    margin-bottom: 15px;
}

/deep/ .num .el-input .el-input__inner {
    font-size: 18px !important;
}

::v-deep .addPointer {
    cursor: pointer;
}

::v-deep .success-row {
    background-color: #81d3f8 !important;
}

/deep/.SCADL-input .public_optionSty .el-input input {
    width: 260px !important;
    height: 40px !important;
}

/deep/.SCADL-input .el-date-editor .el-input__inner {
    width: 260px !important;
    height: 40px !important;
    line-height: 40px !important;
}
</style>
